import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { ProgramsComponent } from './pages/programs/programs.component';
import { ProgramDetailsComponent } from './pages/program-details/program-details.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { AnnouncementsComponent } from './pages/announcements/announcements.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { AboutComponent } from './pages/about/about.component';
import { ArticleDetailsComponent } from './pages/article-details/article-details.component';
import { AlbumComponent } from './pages/album/album.component';
import { AnnouncementDetailsComponent } from './pages/announcement-details/announcement-details.component';
import { EventsComponent } from './pages/events/events.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { MainComponent } from './pages/main/main.component';
import { PreRegistrationComponent } from './pages/pre-registration/pre-registration.component';
import { FinanceComponent } from './pages/finance/finance.component';
import { IntegrityComponent } from './pages/integrity/integrity.component';
import { ArchivalDevelopmentComponent } from './pages/archival-development/archival-development.component';
import { CapitalizableInventoryComponent } from './pages/capitalizable-inventory/capitalizable-inventory.component';
import { ReferenceDocumentsComponent } from './pages/reference-documents/reference-documents.component';
import { CommitteesComponent } from './pages/committees/committees.component';
import { TicketValidationComponent } from './pages/ticket-validation/ticket-validation.component';
// import { UserComponent } from './pages/user/user.component';

export const routes: Routes = [
  {
    path: 'inscripcion',
    loadChildren: () =>
      import('./pages/registration/registration.routes').then((m) => m.routes)
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'programas/:type',
        component: ProgramsComponent
      },
      {
        path: 'programas/:type/:id',
        component: ProgramDetailsComponent
      },
      {
        path: 'articulos',
        component: ArticlesComponent
      },
      {
        path: 'articulos/:category',
        component: ArticlesComponent
      },
      {
        path: 'articulo/:id',
        component: ArticleDetailsComponent
      },
      {
        path: 'convocatorias',
        component: AnnouncementsComponent
      },
      {
        path: 'convocatoria/:id',
        component: AnnouncementDetailsComponent
      },
      {
        path: 'galerias',
        component: GalleryComponent
      },
      {
        path: 'album/:name',
        component: AlbumComponent
      },
      {
        path: 'agenda',
        component: EventsComponent
      },
      {
        path: 'agenda/:id',
        component: EventDetailsComponent
      },
      {
        path: 'acerca-de',
        component: AboutComponent
      },
      {
        path: 'preinscripcion',
        component: PreRegistrationComponent
      },
      {
        path: 'pago-de-eventos',
        component: NotFoundComponent
      },
      {
        path: 'pago-de-eventos/formulario',
        component: NotFoundComponent
      },
      {
        path: 'pago-de-eventos/exito',
        component: NotFoundComponent
      },
      {
        path: 'ticket/:token',
        component: TicketValidationComponent
      }
    ]
  },
  // {
  //   path: 'user',
  //   component: UserComponent
  // },
  {
    path: 'terminos-y-condiciones',
    component: TermsAndConditionsComponent
  },
  {
    path: 'aviso-de-privacidad',
    component: PrivacyPolicyComponent
  },
  {
    path: 'finanzas',
    component: FinanceComponent
  },
  {
    path: 'integridad',
    component: IntegrityComponent
  },
  {
    path: 'desarrollo-archivistico',
    component: ArchivalDevelopmentComponent
  },
  {
    path: 'inventario-capitalizable',
    component: CapitalizableInventoryComponent
  },
  {
    path: 'documentos-de-referencia',
    component: ReferenceDocumentsComponent
  },
  {
    path: 'comites',
    component: CommitteesComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
